import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import BlogList from "@/pages/BlogList";
import BlogArticle from "@/pages/BlogArticle";

function App() {
  // Reveal-on-scroll observer for .reveal elements
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
          </Routes>
          <Toaster position="bottom-right" richColors closeButton />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
